import React from 'react'

import Hero from '../hero/hero'
import SlicesWrapper from '../slices/slicesWrapper'
import SolutionsPush from '../solutions/solutionsPush'
import NewsroomFeatured from '../newsroomFeatured'

const LandingLayout = ({data, currentUrl, news, events, socials}) => {
  return (
    <>
      <Hero 
        currentUrl={currentUrl}
        data={data} 
        type="page"
        customType={null}
        blogHubTitle={null} />

      <div>
        <SlicesWrapper slices={data.slices} />

        <NewsroomFeatured news={news} events={events} socials={socials} />

        { data.pushSolutions !== undefined && data.pushSolutions !== null && data.pushSolutions.length > 0 &&
          <SolutionsPush solutions={data.pushSolutions} type="landing" />
        }
      </div>
    </>
  )
}

export default LandingLayout;